__turbopack_context__.v({
  "currency": "transaction-row-module-sass-module__pl4pMW__currency",
  "date": "transaction-row-module-sass-module__pl4pMW__date",
  "details": "transaction-row-module-sass-module__pl4pMW__details",
  "detailsBtn": "transaction-row-module-sass-module__pl4pMW__detailsBtn",
  "label": "transaction-row-module-sass-module__pl4pMW__label",
  "opened": "transaction-row-module-sass-module__pl4pMW__opened",
  "row": "transaction-row-module-sass-module__pl4pMW__row",
  "transactionItem": "transaction-row-module-sass-module__pl4pMW__transactionItem",
});
